<template>
  <page :loading="loading">
    <template #content>
      <v-treeview
        ref="tree"
        :active="active"
        :items="items"
        :open="opened"
        item-key="globalid"
        item-text="name"
        item-disabled=""
        dense
        activatable
        return-object
        @update:active="treeviewOnClick"
      >
      <template v-slot:label="{ item }">
        <div class="disabled" v-if="item.disabled">{{ item.name }}</div>
        <div class="enabled" v-if="!item.disabled">{{ item.name }}</div>
      </template>
    </v-treeview>
    </template>
  </page>
</template>

<script>
export default {
  data() { 
    return {
      loading: true,
      active: [],
      items: [],
      opened: [],
      thisorgitem: null,
    }},
  computed: {
    organization: function () { return this.$route.params.organization },
  },
  created: function () {
    this.load()
  },
  methods: {
    load: function () {
      this.$api.getUserOrganizations(this.username, this.callBack(
        response => {
          const allOrgs = []
          const flatten = (list, role) => {
            list.forEach(element => {
              allOrgs.push({globalid: element, role: role})
            })
          }
          flatten(response.member, "member")
          flatten(response.owner, "owner")
          this.$api.getOrganizationTree(this.organization, this.callBack(
            response => {
              const opened = []
              const addName = element => {
                if (element.globalid == this.organization) this.thisorgitem = element
                opened.push(element)
                element.disabled = allOrgs.filter(org => { return org.globalid == element.globalid }).length == 0
                element.name = element.globalid.split(".").last()
                element.children.forEach(item => { addName(item) })
              }
              addName(response)
              this.items = [ response ]
              this.opened = opened
              this.active.push(this.thisorgitem)
            }, undefined, ()=> {
              this.loading = false
            }
          ))
        }))
    },
    treeviewOnClick: function (selected) {
      if (selected.length != 1) {
        this.active = [this.thisorgitem]
        return
      }
      [selected] = selected
      if (selected.globalid == this.organization || selected.disabled) {
        this.active = [this.thisorgitem]
        return
      }
      this.$router.push({ name: "OrganizationStructure", params: { organization: selected.globalid }})
    }
  }
}
</script>

<style scoped>
.v-treeview {
  width: 50%;
  max-width: 100%;
}

div.disabled {
  color: gray;
  cursor: not-allowed;
}
div.enabled {
  cursor: pointer;
}
</style>